// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"6337":"06a8df6b9d991ce8","9651":"9ad80cd130232bf1"}[chunkId] + ".js";
};